const useBrandImageResolver = (brand: string | unknown, imagePath: string) => {
  const basepath =
    import.meta.env.PUBLIC_APP_CONFIG_ENV === 'development' ? '/sherlock/' : '/'

  return `${basepath}${brand}/${imagePath}`
}

export default useBrandImageResolver
